import dayjs from 'dayjs';
import orderby from 'lodash.orderby';
import api from '../../api/index';
import router from '../../router';

export default {
  namespaced: true,
  modules   : {
  },
  state: {
    modals: [
      {
        type  : 'suggest_idea',
        active: false,
      },
    ],
    ideas: [
      {
        id      : 1,
        title   : 'Решение проблемы хранения продукции…',
        date    : 1543093200000,
        likes   : 112,
        comments: 75,
        theme   : 'Оптимизация данных',
        text    : 'Усовершенствован раздел «База знаний» на портале. Теперь можно скачивать материалы прямо на рабочий компьютер, телефон или планшет. Для реагистрации на портале необходимо запросить логин/пароль у своего…',
      },
    ],
    selected_theme : null,
    selected_number: 10,
    selected_page  : 1,
    sorting        : 'asc',
  },
  getters: {
    ideas          : ({ideas}) => ideas,
    selected_theme : ({selected_theme}) => selected_theme,
    selected_number: ({selected_number}) => selected_number,
    selected_page  : ({selected_page}) => selected_page,
    sorting        : ({sorting}) => sorting,
    filtered_by_theme({ideas, selected_theme}) {
      if (selected_theme && selected_theme!='Все темы') {
        return ideas.filter((item)=> item.theme == selected_theme);
      } else return ideas;
    },
    search_ideas: ({ideas, selected_theme}, {filtered_by_theme}, rootState, {})=> {
      let search_string = rootState.activity.search_string;
      if (search_string) {
        if (selected_theme) {
          return filtered_by_theme.filter((x)=> x.title ? x.title.toLowerCase().includes(search_string.toLowerCase()) : x.text.toLowerCase().includes(search_string.toLowerCase()));
        } else {
          return ideas.filter((x)=> x.title ? x.title.toLowerCase().includes(search_string.toLowerCase()) : x.text.toLowerCase().includes(search_string.toLowerCase()));
        }
      } else return ideas;
    },
    paginated({selected_number, selected_page, sorting}, {filtered_by_theme, search_ideas}, rootState) {
      let search_string = rootState.activity.search_string;
      let search_filtered = search_string ? search_ideas : filtered_by_theme;
      let asc = orderby(search_filtered, (o) => o.date, 'asc');
      let desc = orderby(search_filtered, (o) => o.date, 'desc');
      if (sorting == 'asc') {
        return asc.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      } else if (sorting == 'desc') {
        return desc.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      } else {
        return search_filtered.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      }
    },
  },
  mutations: {
    SET_ACTIVITY_IDEAS(state, value) {
      state.ideas = value;
      state.ideas.forEach((x)=> {
        x.date = x.date*1000;
      });
    },
    SET_SELECTED_THEME(state, value) {
      state.selected_theme = value;
    },
    SET_SELECTED_PAGE(state, value) {
      state.selected_page = value;
    },
    SHOW_NUMBER(state, obj) {
      const {array, selected} = obj;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    SORT_BY_DATE(state, selected) {
      if (selected=='Сначала новые') {
        state.sorting = 'desc';
      } else if (selected=='Сначала старые') {
        state.sorting = 'asc';
      }
    },
    CLEAR_IDEAS_PAGES(state) {
      state.selected_page = 1;
    },
    SEND_IDEA(state, {idea}) {
      state.ideas.push(idea);
    },
  },
  actions: {
    show_number({commit, getters}, event) {
      const {filtered_by_theme} = getters;
      commit('CLEAR_IDEAS_PAGES');
      commit('SHOW_NUMBER', {array: filtered_by_theme, selected: event});
    },
    sorting_by_date({commit}, selected) {
      commit('SORT_BY_DATE', selected);
      commit('CLEAR_IDEAS_PAGES');
    },
    send_idea({commit, rootGetters, dispatch}, idea) {
      const user = rootGetters['profile/user/user'];
      let new_idea = {
        title   : idea.title,
        theme   : idea.theme,
        text    : idea.text,
        file    : idea.files,
        likes   : 0,
        comments: 0,
        author  : {
          name   : `${user.name} ${user.patronymic} ${user.family}`,
          avatar : user.avatar,
          rank   : user.rank || '',
          chevron: user.chevron || '',
        },
      };
      dispatch('post_idea', new_idea);
      // commit('SEND_IDEA', {idea: new_idea});
      commit('CLOSE_MODAL', 'ideas_bank_modal');
    },
    async post_idea({}, new_idea) {
      try {
        const post_idea = await api.ideas_bank.post_idea(new_idea);
        return post_idea;
      } catch (err) {
        if (err.message.indexOf('401')!=-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
    async like_idea({state, commit}, id) {
      let likedIdea = state.ideas.find((idea) => idea.id == id);
      commit('TO_LIKED', likedIdea);
      try {
        if (likedIdea.liked) {
          await api.ideas_bank.like_idea(likedIdea.id);
        } else {
          await api.ideas_bank.unlike_idea(likedIdea.id);
        }
      } catch (err) {
        if (err.message.indexOf('401')!=-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
  },
};
